import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { User } from '../models/auth.models';
import { GlobalService } from './global.service';

@Injectable({ providedIn: 'root' })
export class AuthfakeauthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(public globalService: GlobalService,private http: HttpClient) {
       
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(sessionStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(nombre: string, password: string) {
        console.log(this.globalService.api + 'seguridad/login.php');
        return this.http.post<any>(this.globalService.api + 'seguridad/login.php', { nombre, password })
            .pipe(map(data => {
                console.log('pa2');
                var user=data[0];  
                console.log(user);
                // login successful if there's a jwt token in the response
                if (user && user.token) {
                    this.globalService.club=[];
                    localStorage.removeItem('clientecarrito');
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    sessionStorage.setItem('currentUser', JSON.stringify(user));
                    this.currentUserSubject.next(user);
                }
                return user;
            }));
    }

    logout() {
        // remove user from local storage to log user out
        this.globalService.club=[];
        localStorage.removeItem('clientecarrito');
        sessionStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }
}
